@if (data['type'] ==='image') {
    <img [src]="data['imageUrl']" alt="">
} @else {
    <div class="card p-3">
        <h4 [ngStyle]="{'font-size': data['fontSize']}">{{data['value']}}</h4>
    </div>
}